import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import { colors } from 'Themes/Colors'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      margin: 'auto',
    },
    image: {
      display: 'flex',
      width: 'auto',
    },
    title: {
      fontWeight: 600,
    },
    box: {
      backgroundColor: colors.resiliaWhite,
      border: `1px solid ${colors.backgroundGrey}`,
    },
  })
)

export default useStyles
